import React from "react";
import logo from "../../../assets/images/meradoc.png";

const MobileReponseShow = () => {
  return (
    <div>
      <div className="mobileResponseShow p-4">
        <p>
          <div className="px-3 py-4">
            <img src={logo} alt="logo" width="80%"></img>
          </div>
          Not Accessible on Mobile Phones - Please use laptop/PC to access the
          platform
        </p>
      </div>
    </div>
  );
};

export default MobileReponseShow;
